/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S4_P1_DaysInputs */

const tr_kvkkbasvuru_s4_p1_days = /** @type {(inputs: Kvkkbasvuru_S4_P1_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 (otuz) gün`)
};

const en_kvkkbasvuru_s4_p1_days = /** @type {(inputs: Kvkkbasvuru_S4_P1_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 (thirty) days`)
};

const de_kvkkbasvuru_s4_p1_days = /** @type {(inputs: Kvkkbasvuru_S4_P1_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 (dreißig) Tagen`)
};

const ru_kvkkbasvuru_s4_p1_days = /** @type {(inputs: Kvkkbasvuru_S4_P1_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 (тридцати) дней`)
};

/**
* | output |
* | --- |
* | "30 (thirty) days" |
*
* @param {Kvkkbasvuru_S4_P1_DaysInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s4_p1_days = /** @type {((inputs?: Kvkkbasvuru_S4_P1_DaysInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S4_P1_DaysInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s4_p1_days(inputs)
	if (locale === "de") return de_kvkkbasvuru_s4_p1_days(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s4_p1_days(inputs)
	return tr_kvkkbasvuru_s4_p1_days(inputs)
});